import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessToasterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 16,
		fill: "#3DD394"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.4 12.4L14.5302 18.092C14.1289 18.4811 13.4867 18.4658 13.1045 18.0581L10.8 15.6",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgSuccessToasterIcon;
